import React from 'react';
import { Clock, Save, Trash2 } from 'lucide-react';

interface BookFormFooterProps {
  onClose: () => void;
  isSubmitting: boolean;
  isEdit: boolean;
  isDisabled?: boolean;
  onDelete?: () => void;
}

export const BookFormFooter: React.FC<BookFormFooterProps> = ({
  onClose,
  isSubmitting,
  isEdit,
  isDisabled = false,
  onDelete,
}) => {
  return (
    <>
      {/* Auto-Approve Information Note */}
      <div className="bg-indigo-50/70 border border-indigo-100/50 rounded-xl p-3 flex items-start gap-2.5">
        <Clock className="w-4 h-4 text-indigo-600 shrink-0 mt-0.5 animate-pulse" />
        <div className="text-xs text-slate-600">
          <span className="font-bold text-indigo-900">Jaminan Persetujuan 24 Jam:</span>{' '}
          Pengajuan UIBN baru Anda akan diverifikasi oleh Admin. Jika tidak ada tindakan dari Admin
          dalam waktu <b>1×24 jam setelah pengajuan</b>, sistem akan menyetujui UIBN secara otomatis.
        </div>
      </div>

      <div className="pt-4 border-t border-slate-100 flex items-center justify-between gap-2.5">
        <div>
          {onDelete && (
            <button
              type="button"
              onClick={onDelete}
              className="px-3.5 py-2 text-xs font-semibold text-rose-600 hover:text-rose-700 bg-rose-50 hover:bg-rose-100 border border-rose-200 rounded-xl transition cursor-pointer flex items-center gap-1.5 min-h-[44px]"
              title="Hapus Draft UIBN ini secara permanen"
            >
              <Trash2 className="w-3.5 h-3.5 text-rose-600" />
              <span>Hapus Draft</span>
            </button>
          )}
        </div>
        <div className="flex items-center gap-2.5">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-xs font-semibold text-slate-600 hover:bg-slate-100 rounded-xl transition cursor-pointer min-h-[44px] flex items-center justify-center"
          >
            Batal
          </button>
          <button
            type="submit"
            disabled={isSubmitting || isDisabled}
            className="px-5 py-2 text-xs font-semibold bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl shadow-xs transition flex items-center justify-center gap-1.5 disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed min-h-[44px]"
          >
            <Save className="w-4 h-4" />
            <span>
              {isSubmitting
                ? 'Menyimpan...'
                : isEdit
                ? 'Simpan Perubahan'
                : 'Daftarkan & Dapatkan UIBN'}
            </span>
          </button>
        </div>
      </div>
    </>
  );
};
